export var DetailsTableColumnWidth = {
    TASK: 486,
    STATUS: 190,
    ACCURACY: 128,
    TIME: 100,
    STRUGGLE: 24,
};
